import { Directive, Input, OnInit, ElementRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[p]'
})
export class PaddingDirective implements OnInit {
  @Input() p = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const paddingKeys = Object.keys(this.p);

      paddingKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`p-${this.p[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`p-${key}-${this.p[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed paddings\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[pt]'
})
export class PaddingTopDirective implements OnInit {
  @Input() pt = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const paddingKeys = Object.keys(this.pt);

      paddingKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`pt-${this.pt[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`pt-${key}-${this.pt[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed paddings\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[pb]'
})
export class PaddingBottomDirective implements OnInit {
  @Input() pb = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const paddingKeys = Object.keys(this.pb);

      paddingKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`pb-${this.pb[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`pb-${key}-${this.pb[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed paddings\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[pl]'
})
export class PaddingLeftDirective implements OnInit {
  @Input() pl = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const paddingKeys = Object.keys(this.pl);

      paddingKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`pl-${this.pl[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`pl-${key}-${this.pl[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed paddings\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[pr]'
})
export class PaddingRightDirective implements OnInit {
  @Input() pr = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const paddingKeys = Object.keys(this.pr);

      paddingKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`pr-${this.pr[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`pr-${key}-${this.pr[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed paddings\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[px]'
})
export class PaddingHorizontalDirective implements OnInit {
  @Input() px = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const paddingKeys = Object.keys(this.px);

      paddingKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`px-${this.px[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`px-${key}-${this.px[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed paddings\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[py]'
})
export class PaddingVerticalDirective implements OnInit {
  @Input() py = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const paddingKeys = Object.keys(this.py);

      paddingKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`py-${this.py[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`py-${key}-${this.py[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed paddings\`: ${err}`);
    }
  }
}
